/* Yesica Angelica Editorial — interacciones */
(function () {
  'use strict';

  function initCarousel(root) {
    if (!root || root.dataset.ready) return;
    var track = root.querySelector('[data-track]');
    if (!track) return;
    root.dataset.ready = '1';
    var scope = root.closest('[data-carousel-scope]') || root;
    var prev = scope.querySelector('[data-prev]');
    var next = scope.querySelector('[data-next]');
    var bar = scope.querySelector('[data-bar]');
    var count = scope.querySelector('[data-count]');
    var gallery = root.closest('[data-gallery]');
    var thumbs = gallery ? gallery.querySelectorAll('[data-thumb]') : [];

    function gap() {
      var s = getComputedStyle(track);
      return parseFloat(s.columnGap) || parseFloat(s.gap) || 0;
    }
    function step() {
      var first = track.children[0];
      return first ? first.getBoundingClientRect().width + gap() : track.clientWidth;
    }
    function index() {
      var s = step();
      return s ? Math.round(track.scrollLeft / s) : 0;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) {
        var visible = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        var w = Math.max(visible * 100, 8);
        bar.style.width = w + '%';
        bar.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - w) : 0) + '%';
      }
      var i = index();
      if (count) count.textContent = (i + 1) + ' / ' + track.children.length;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', update);
    root.goTo = function (k) { track.scrollTo({ left: k * step(), behavior: 'smooth' }); };
    update();
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        initReadmore(root);
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
        var target = list[(i + list.length) % list.length];
        target.focus(); target.click();
      });
    });
  }

  function initQty(root) {
    var input = root.querySelector('input');
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var v = (parseInt(input.value, 10) || 1) + (b.dataset.step === '+' ? 1 : -1);
      input.value = Math.max(1, v);
    });
  }

  function initVariantSelect(select) {
    var section = select.closest('[data-product-section]');
    if (!section) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var idInput = section.querySelector('[data-variant-id]');
      if (idInput) idInput.value = opt.value;
      var price = section.querySelector('[data-price]');
      if (price) price.textContent = opt.dataset.price;
      var compare = section.querySelector('[data-compare]');
      var box = section.querySelector('[data-price-box]');
      if (compare) {
        compare.textContent = opt.dataset.compare || '';
        compare.hidden = !opt.dataset.compare;
      }
      if (box) box.classList.toggle('is-sale', !!opt.dataset.compare);
      var add = section.querySelector('[data-add]');
      if (add) {
        var available = opt.dataset.available === 'true';
        add.disabled = !available;
        var label = add.querySelector('[data-add-text]');
        if (label) label.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel;
      }
      var bn = section.querySelector('[data-buy-now]');
      if (bn) bn.disabled = opt.dataset.available !== 'true';
      section.querySelectorAll('[data-vp]').forEach(function (b) {
        var on = b.getAttribute('data-vp') === opt.value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var vName = section.querySelector('[data-variant-name]');
      if (vName && opt.dataset.title) vName.textContent = opt.dataset.title;
      if (opt.dataset.ext) {
        section.querySelectorAll('[data-ext-link]').forEach(function (a) { a.href = opt.dataset.ext; });
      }
      var sPrice = section.querySelector('[data-sticky-price]');
      if (sPrice) sPrice.textContent = opt.dataset.price;
      var sSel = section.querySelector('[data-sticky-select]');
      if (sSel && sSel.value !== opt.value) sSel.value = opt.value;
      var sAdd = section.querySelector('[data-sticky-add]');
      if (sAdd) {
        var ok = opt.dataset.available === 'true';
        sAdd.disabled = !ok;
        var sTxt = sAdd.querySelector('[data-sticky-add-text]');
        if (sTxt) sTxt.textContent = ok ? sAdd.dataset.addLabel : sAdd.dataset.soldLabel;
      }
      if (opt.dataset.media) {
        var slide = section.querySelector('[data-media-id="' + opt.dataset.media + '"]');
        var carousel = section.querySelector('.gallery[data-carousel]');
        if (slide && carousel && carousel.goTo) {
          carousel.goTo(Array.prototype.indexOf.call(slide.parentNode.children, slide));
        }
      }
      if (select.hasAttribute('data-no-url')) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    });
  }

  function initShare(btn) {
    btn.addEventListener('click', function () {
      var url = btn.dataset.url || window.location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var label = btn.querySelector('[data-share-label]');
          if (!label) return;
          var old = label.textContent;
          label.textContent = btn.dataset.copied;
          setTimeout(function () { label.textContent = old; }, 2000);
        });
      }
    });
  }

  function initRecommendations(el) {
    if (!el.dataset.url) {
      var w0 = el.closest('[data-recommendations-wrap]');
      if (w0 && !el.querySelector('.card') && !Shopify_designMode()) w0.hidden = true;
      return;
    }
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.card')) {
          el.innerHTML = fresh.innerHTML;
          el.querySelectorAll('[data-carousel]').forEach(initCarousel);
        } else if (!el.querySelector('.card')) {
          var wrap = el.closest('[data-recommendations-wrap]');
          if (wrap) wrap.hidden = true;
        }
      })
      .catch(function () {});
  }

  /* ---------- «Combínalo con»: productos complementarios ---------- */
  function initComplementary(el) {
    if (el.dataset.ready || !el.dataset.url) return;
    el.dataset.ready = '1';
    var limit = parseInt(el.dataset.limit, 10) || 2;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var list = el.querySelector('[data-comp-list]');
        var n = 0;
        tmp.querySelectorAll('.comp__item').forEach(function (item) {
          if (n >= limit || item.dataset.id === el.dataset.self) return;
          list.appendChild(item);
          n++;
        });
        if (n > 0) el.hidden = false;
      })
      .catch(function () {});
  }

  function Shopify_designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  function initExcerpt(el) {
    if (el.scrollHeight <= el.clientHeight + 10) el.classList.add('is-short');
  }


  function initReadmore(root) {
    root.querySelectorAll('[data-readmore]').forEach(function (box) {
      if (box.dataset.measured || box.offsetParent === null) return;
      var inner = box.querySelector('.readmore__inner');
      var btn = box.querySelector('[data-readmore-btn]');
      var limit = parseFloat(getComputedStyle(box).getPropertyValue('--rm-h')) || 240;
      box.dataset.measured = '1';
      if (inner.scrollHeight > limit + 24) {
        box.classList.add('is-collapsed');
        btn.hidden = false;
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var open = box.classList.toggle('is-collapsed') === false;
          btn.textContent = open ? btn.dataset.less : btn.dataset.more;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (!open) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      }
    });
  }

  /* ---------- Zoom que sigue el cursor (sin salir del recuadro) ---------- */
  function initZoom(gallery) {
    if (gallery.dataset.zoomReady || gallery.dataset.zoomOn === 'false') return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    gallery.dataset.zoomReady = '1';
    var level = parseFloat(gallery.dataset.zoom) || 1.75;
    gallery.querySelectorAll('.gallery__slide').forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img || slide.querySelector('video, iframe, model-viewer')) return;
      slide.classList.add('gallery__slide--zoom');
      function move(e) {
        var r = img.getBoundingClientRect();
        var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
        var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
        img.style.transformOrigin = x + '% ' + y + '%';
      }
      slide.addEventListener('mouseenter', function (e) {
        move(e);
        slide.classList.add('is-zooming');
        img.style.transform = 'scale(' + level + ')';
      });
      slide.addEventListener('mousemove', move);
      slide.addEventListener('mouseleave', function () {
        slide.classList.remove('is-zooming');
        img.style.transform = '';
      });
    });
  }

  /* ---------- Barra fija de compra ---------- */
  function initStickyBuy(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var section = bar.closest('[data-product-section]');
    var anchor = section && (section.querySelector('.buy__row') || section.querySelector('.ext-buy') || section.querySelector('.product__info'));
    if (!anchor || !('IntersectionObserver' in window)) return;
    var sel = bar.querySelector('[data-sticky-select]');
    if (sel) {
      sel.addEventListener('change', function () {
        var main = section.querySelector('[data-variant-select]');
        if (!main) return;
        main.value = sel.value;
        main.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    var focusables = bar.querySelectorAll('a, button, select');
    function show(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      focusables.forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      document.body.classList.toggle('has-sticky-buy', on);
    }
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      show(!en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(anchor);
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-tabs]').forEach(initTabs);
    root.querySelectorAll('[data-qty]').forEach(initQty);
    root.querySelectorAll('[data-variant-select]').forEach(initVariantSelect);
    root.querySelectorAll('[data-share]').forEach(initShare);
    root.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    root.querySelectorAll('[data-excerpt]').forEach(initExcerpt);
    root.querySelectorAll('[data-zoom]').forEach(initZoom);
    root.querySelectorAll('[data-complementary]').forEach(initComplementary);
    root.querySelectorAll('[data-sticky-buy]').forEach(initStickyBuy);
    initReadmore(root);
    root.querySelectorAll('[data-default-country]').forEach(function (s) {
      var v = s.dataset.defaultCountry;
      if (v) s.value = v;
    });
  }


  /* ---------- Carrito sin recargar ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var t = document.getElementById('CartToast');
    if (!t) return;
    var text = t.querySelector('[data-toast-text]');
    if (!t.dataset.defaultText) t.dataset.defaultText = text.textContent;
    text.textContent = msg || t.dataset.defaultText;
    t.classList.toggle('is-error', !!isError);
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 4500);
  }
  function refreshCount() {
    var base = (window.themeRoutes && window.themeRoutes.cart) || '/cart';
    fetch(base + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pr = document.querySelector('[data-promo-root]');
        if (pr) pr.dataset.items = cart.item_count;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      }).catch(function () {});
  }
  function formatMoney(cents) {
    var fmt = window.themeMoneyFormat || '${{amount}}';
    function sep(n, dec, th, dp) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dp);
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = sep(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = sep(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = sep(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': val = sep(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': val = sep(cents, 2, "'", '.'); break;
      default: val = sep(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }
  function esc(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }
  function openUpsell(item) {
    var dlg = document.getElementById('UpsellPopup');
    if (!dlg || typeof dlg.showModal !== 'function') return false;
    var added = dlg.querySelector('[data-up-added]');
    var img = item.image ? item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=200' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="up__variant">' + esc(item.variant_title) + '</span>' : '';
    added.innerHTML =
      (img ? '<img src="' + esc(img) + '" alt="" width="80" height="80">' : '') +
      '<div><strong>' + esc(item.product_title || item.title) + '</strong>' + variant +
      '<span class="up__qty">' + esc(item.quantity) + ' × ' + esc(formatMoney(item.final_price != null ? item.final_price : item.price)) + '</span></div>';
    var recs = dlg.querySelector('[data-up-recs]');
    var list = dlg.querySelector('[data-up-list]');
    recs.hidden = true;
    list.innerHTML = '';
    if (!dlg.open) dlg.showModal();
    var base = (window.themeRoutes && window.themeRoutes.recommendations) || '/recommendations/products';
    fetch(base + '?section_id=cart-upsell&product_id=' + item.product_id + '&limit=' + (window.themeUpsellCount || 3) + '&intent=related')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var items = tmp.querySelector('[data-upsell-items]');
        if (items && items.querySelector('.up__item')) {
          list.innerHTML = '';
          list.appendChild(items);
          recs.hidden = false;
        }
      })
      .catch(function () {});
    return true;
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-up-close]')) return;
    var dlg = document.getElementById('UpsellPopup');
    if (dlg) dlg.close();
  });
  document.addEventListener('click', function (e) {
    var dlg = document.getElementById('UpsellPopup');
    if (dlg && e.target === dlg) dlg.close();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var url = ((window.themeRoutes && window.themeRoutes.cartAdd) || '/cart/add') + '.js';
    fetch(url, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message, true); return; }
        refreshCount();
        var up = document.getElementById('UpsellPopup');
        if (up && up.contains(form)) {
          var label = btn && btn.querySelector('span');
          if (label && btn.dataset.done) label.textContent = btn.dataset.done;
          if (btn) btn.classList.add('is-done');
          return;
        }
        var dlg = document.getElementById('QuickView');
        if (dlg && dlg.open && dlg.contains(form)) dlg.close();
        var item = res.data && res.data.items ? res.data.items[0] : res.data;
        var upOpened = item && item.product_id && openUpsell(item);
        if (!upOpened) toast();
        promoOnAdd(!!upOpened);
      })
      .catch(function () { form.removeAttribute('data-ajax-cart'); form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  /* ---------- Variantes con foto / botones ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vp]');
    if (!b) return;
    var field = b.closest('.vp-field');
    var sel = field && field.querySelector('[data-variant-select]');
    if (!sel || sel.value === b.getAttribute('data-vp')) return;
    sel.value = b.getAttribute('data-vp');
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var b = e.target.closest && e.target.closest('[data-vp]');
    if (!b) return;
    var all = Array.prototype.slice.call(b.parentNode.querySelectorAll('[data-vp]'));
    var n = all[(all.indexOf(b) + (e.key === 'ArrowRight' ? 1 : -1) + all.length) % all.length];
    n.focus(); n.click(); e.preventDefault();
  });

  /* ---------- Vista rápida ---------- */
  function openQuickView(productUrl) {
    var dlg = document.getElementById('QuickView');
    if (!dlg || typeof dlg.showModal !== 'function') { window.location.href = productUrl; return; }
    var body = dlg.querySelector('[data-qv-body]');
    body.innerHTML = '<div class="qv__spinner" aria-hidden="true"></div>';
    body.classList.add('is-loading');
    dlg.showModal();
    var sep = productUrl.indexOf('?') === -1 ? '?' : '&';
    fetch(productUrl + sep + 'section_id=quick-view')
      .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var grid = tmp.querySelector('.qv__grid');
        if (!grid) throw new Error();
        body.classList.remove('is-loading');
        body.innerHTML = '';
        body.appendChild(grid);
        init(body);
      })
      .catch(function () { window.location.href = productUrl; });
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var upd = document.getElementById('UpsellPopup');
      if (upd && upd.open) upd.close();
      openQuickView(trigger.getAttribute('data-quick-view'));
      return;
    }
    var buyNow = e.target.closest('[data-buy-now]');
    if (buyNow) {
      var bform = buyNow.closest('form');
      if (!bform) return;
      buyNow.disabled = true;
      var addUrl = ((window.themeRoutes && window.themeRoutes.cartAdd) || '/cart/add') + '.js';
      fetch(addUrl, { method: 'POST', body: new FormData(bform), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.data.description || res.data.message, true); buyNow.disabled = false; return; }
          window.location.href = '/checkout';
        })
        .catch(function () { buyNow.disabled = false; });
      return;
    }
    if (e.target.closest('[data-qv-close]')) {
      document.getElementById('QuickView').close();
      return;
    }
    var dlg = document.getElementById('QuickView');
    if (dlg && e.target === dlg) dlg.close();
  });


  /* ---------- Filtros y orden de la colección ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches('[data-sort-select]')) {
      var form = document.querySelector('[data-filter-form]');
      if (form) {
        var hidden = form.querySelector('input[name="sort_by"]');
        if (!hidden) { hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'sort_by'; form.appendChild(hidden); }
        hidden.value = el.value;
        form.submit();
      } else {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', el.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }
      return;
    }
    if (el.matches('[data-filter-form] input[type="checkbox"]')) {
      el.form.submit();
    }
  });
  function openFiltersOnDesktop() {
    var d = document.querySelector('[data-filters-details]');
    if (d && window.matchMedia('(min-width: 990px)').matches) d.open = true;
  }
  document.addEventListener('DOMContentLoaded', openFiltersOnDesktop);


  /* ---------- Ventanas emergentes: libro nuevo y descuento ---------- */
  var PROMO_UI = {
    es: { 'new': 'Nuevo', by: 'por', copy: 'Copiar', copied: '¡Copiado!', apply: 'Aplicar al carrito', added: '¡Añadido al carrito!', view_cart: 'Ver carrito', 'continue': 'Seguir comprando' },
    fr: { 'new': 'Nouveau', by: 'par', copy: 'Copier', copied: 'Copié !', apply: 'Appliquer au panier', added: 'Ajouté au panier !', view_cart: 'Voir le panier', 'continue': 'Continuer vos achats' },
    en: { 'new': 'New', by: 'by', copy: 'Copy', copied: 'Copied!', apply: 'Apply to cart', added: 'Added to cart!', view_cart: 'View cart', 'continue': 'Keep shopping' }
  };
  var promoRoot, promoText = {}, promoLangCode = 'es';
  function store(kind, key, val) {
    try {
      var st = kind === 'session' ? window.sessionStorage : window.localStorage;
      if (val === undefined) return st.getItem(key);
      st.setItem(key, val);
    } catch (e) { return null; }
  }
  function detectLang() {
    if (promoRoot && parseInt(promoRoot.dataset.locales, 10) > 1 && promoRoot.dataset.locale) {
      var sl = promoRoot.dataset.locale.slice(0, 2).toLowerCase();
      return PROMO_UI[sl] ? sl : 'en';
    }
    var l = gtCookie();
    if (!l) l = (navigator.languages && navigator.languages[0]) || navigator.language || 'es';
    l = String(l).slice(0, 2).toLowerCase();
    return PROMO_UI[l] ? l : 'en';
  }
  function tr(key) { return (promoText[promoLangCode] || {})[key] || (promoText.es || {})[key] || ''; }
  function ui(key) { return (PROMO_UI[promoLangCode] || PROMO_UI.es)[key]; }
  function applyLang(scope) {
    scope.querySelectorAll('[data-i18n]').forEach(function (el) { var t = tr(el.dataset.i18n); if (t) el.textContent = t; });
    scope.querySelectorAll('[data-ui]').forEach(function (el) { var t = ui(el.dataset.ui); if (t) el.textContent = t; });
  }
  function anyDialogOpen() { return !!document.querySelector('dialog[open]'); }
  function openPromo(id) {
    var d = document.getElementById(id);
    if (!d || typeof d.showModal !== 'function' || d.open) return false;
    if (anyDialogOpen()) return false;
    d.showModal();
    return true;
  }
  function openDiscount(exit) {
    var d = document.getElementById('PromoDiscount');
    if (!d) return false;
    var h = d.querySelector('[data-promo-heading]');
    if (h) h.textContent = tr(exit ? 'exit_heading' : 'discount_heading') || tr('discount_heading');
    return openPromo('PromoDiscount');
  }
  function buildStrip(code) {
    var wrap = document.createElement('div');
    wrap.className = 'up__promo-inner';
    var p = document.createElement('p');
    var parts = (tr('strip_text') || '[codigo]').split('[codigo]');
    p.appendChild(document.createTextNode(parts[0] || ''));
    var b = document.createElement('strong');
    b.textContent = code;
    p.appendChild(b);
    p.appendChild(document.createTextNode(parts.slice(1).join(code) || ''));
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn promo__copy-btn';
    btn.setAttribute('data-promo-copy', code);
    btn.textContent = ui('copy');
    wrap.appendChild(p);
    wrap.appendChild(btn);
    return wrap;
  }
  function promoOnAdd(upOpened) {
    if (!promoRoot) return;
    var code = promoRoot.dataset.code;
    if (!code || promoRoot.dataset.onAdd !== 'true') return;
    var slot = document.querySelector('[data-up-promo]');
    if (upOpened && slot) {
      slot.innerHTML = '';
      slot.appendChild(buildStrip(code));
      slot.hidden = false;
    } else if (!store('session', 'yamc_promo_add')) {
      if (openDiscount(false)) store('session', 'yamc_promo_add', '1');
    }
  }
  function initPromos() {
    promoRoot = document.querySelector('[data-promo-root]');
    if (!promoRoot) return;
    try { promoText = JSON.parse(promoRoot.querySelector('[data-promo-i18n]').textContent); } catch (e) { promoText = {}; }
    promoLangCode = detectLang();
    applyLang(promoRoot);
    var up = document.getElementById('UpsellPopup');
    if (up) applyLang(up);
    var design = promoRoot.dataset.design === 'true';
    var isHome = promoRoot.dataset.template === 'index';

    /* Libro nuevo: en la página de inicio, una vez cada X días */
    var book = document.getElementById('PromoBook');
    if (book && isHome && !design) {
      var days = parseInt(promoRoot.dataset.bookDays, 10) || 3;
      var last = parseInt(store('local', 'yamc_promo_book') || '0', 10);
      if (Date.now() - last > days * 864e5) {
        setTimeout(function () {
          if (openPromo('PromoBook')) store('local', 'yamc_promo_book', String(Date.now()));
        }, (parseInt(promoRoot.dataset.bookDelay, 10) || 0) * 1000);
      }
    }
    var code = promoRoot.dataset.code;
    if (!code || design) return;

    /* Descuento en la página de inicio (opcional) */
    if (isHome && promoRoot.dataset.onHome === 'true' && !store('session', 'yamc_promo_home')) {
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (tries > 20) { clearInterval(t); return; }
        if (anyDialogOpen()) return;
        if (tries < 3 && book && !store('local', 'yamc_promo_book')) return;
        clearInterval(t);
        if (openDiscount(false)) store('session', 'yamc_promo_home', '1');
      }, 4000);
    }

    /* Al querer irse con productos en el carrito */
    if (promoRoot.dataset.onExit === 'true') {
      var armedAt = Date.now();
      var tryExit = function () {
        if (store('session', 'yamc_promo_exit')) return;
        if ((parseInt(promoRoot.dataset.items, 10) || 0) < 1) return;
        if (Date.now() - armedAt < 5000) return;
        if (openDiscount(true)) store('session', 'yamc_promo_exit', '1');
      };
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) tryExit();
      });
      var hiddenAt = 0;
      document.addEventListener('visibilitychange', function () {
        if (!window.matchMedia('(hover: none)').matches) return;
        if (document.visibilityState === 'hidden') hiddenAt = Date.now();
        else if (hiddenAt && Date.now() - hiddenAt > 3000) tryExit();
      });
    }
  }
  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-promo-close]');
    var dlg = e.target.closest('dialog.promo');
    if (close && dlg) { dlg.close(); return; }
    if (e.target.matches && e.target.matches('dialog.promo')) { e.target.close(); return; }
    var copy = e.target.closest('[data-promo-copy]');
    if (copy) {
      var val = copy.getAttribute('data-promo-copy');
      var done = function () {
        copy.textContent = ui('copied');
        copy.classList.add('is-done');
        setTimeout(function () { copy.textContent = ui('copy'); copy.classList.remove('is-done'); }, 2200);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(val).then(done, done);
      else done();
    }
  });
  document.addEventListener('DOMContentLoaded', initPromos);

  /* ---------- Google Traductor ---------- */
  function gtCookie() {
    var m = document.cookie.match(/(?:^|;\s*)googtrans=([^;]+)/);
    return m ? decodeURIComponent(m[1]).split('/').pop() : '';
  }
  function setGt(lang) {
    var host = window.location.hostname;
    var parts = host.split('.');
    var root = parts.length > 1 ? '.' + parts.slice(-2).join('.') : host;
    var expire = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
    [host, root, ''].forEach(function (d) {
      var dom = d ? '; domain=' + d : '';
      if (lang) document.cookie = 'googtrans=/auto/' + lang + '; path=/' + dom;
      else document.cookie = 'googtrans=; ' + expire + '; path=/' + dom;
    });
    window.location.reload();
  }
  function loadGt() {
    if (document.getElementById('gt-script')) return;
    var holder = document.createElement('div');
    holder.id = 'google_translate_element';
    document.body.appendChild(holder);
    window.googleTranslateElementInit = function () {
      try { new window.google.translate.TranslateElement({ pageLanguage: document.documentElement.lang || 'es', autoDisplay: false }, 'google_translate_element'); } catch (e) {}
    };
    var sc = document.createElement('script');
    sc.id = 'gt-script';
    sc.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    sc.async = true;
    document.body.appendChild(sc);
  }
  document.addEventListener('DOMContentLoaded', function () {
    var selects = document.querySelectorAll('[data-gt-select]');
    if (!selects.length) return;
    var current = gtCookie();
    selects.forEach(function (sel) {
      if (current) sel.value = current;
      sel.addEventListener('change', function () { setGt(sel.value); });
    });
    if (current) loadGt();
  });


  /* ---------- Cuenta regresiva (página de contraseña) ---------- */
  function initCountdown(el) {
    var raw = (el.dataset.countdown || '').trim().replace(' ', 'T');
    var target = new Date(raw);
    if (isNaN(target)) { el.hidden = true; return; }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = Math.max(0, target - new Date());
      var s = Math.floor(diff / 1000);
      var map = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Object.keys(map).forEach(function (k) {
        var n = el.querySelector('[data-cd="' + k + '"]');
        if (n) n.textContent = pad(map[k]);
      });
      if (diff <= 0) clearInterval(timer);
    }
    var timer = setInterval(tick, 1000);
    tick();
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-countdown]').forEach(initCountdown);
  });

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  /* Editor de temas: reiniciar al editar una sección */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
